export interface IntroSlide {
  id: 't1' | 't2' | 't3';
  imageSrc: string;
}

export const INTRO_SLIDES: readonly IntroSlide[] = [
  { id: 't1', imageSrc: '/images/feed-widget/slide-1.png' },
  { id: 't2', imageSrc: '/images/feed-widget/slide-2.png' },
  { id: 't3', imageSrc: '/images/feed-widget/slide-3.png' },
] as const;
